// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar1 {
  background-color: #939393;
  padding: 1rem 0;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  position: relative;
}

.logo {
  border-radius: 5rem;
  position: absolute;
  left: 5vw;
}

.scrolltext-icon {
  color: #000000;
  height: 3rem;
  width: 3rem;
  cursor: pointer;
  border-radius: 50%;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }
}

.logged-in-avatar {
  height: 3rem;
  width: 3rem;
  cursor: pointer;
  border-radius: 50%;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.5);
  }
}

.navbar-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.75rem;
  transition: color 0.3s;
  margin-bottom: 1rem;

  &:hover {
    color: #76bbe9;
  }
}

.navbar-item {
  justify-content: start;
  /* align-items: center; */
  text-decoration: none;
  color: #ffffff;
  font-weight: 800;
  font-size: 1.7rem;
  flex-wrap: wrap;
  transition: color 0.3s;
  margin-bottom: 1rem;

  &:hover {
    color: #76bbe9;
  }
}

.navbar-link {
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  font-weight: 800;
  font-size: 1.5rem;
  transition: color 0.3s;
  margin-bottom: 1rem;

  &:hover {
    color: #76bbe9;
  }
}

.dropdown {
  display: none;
  position: absolute;
  background-color: #939393;
  list-style-type: none;
  padding: 0;
  margin: 0;
  top: 100%;
  left: 0;
  z-index: 1;
  cursor: pointer;
}

.navbar-item:hover .dropdown {
  display: block;
}

.dropdown .navbar-link {
  padding: 10px 15px 10px 0;
  display: block;
  white-space: nowrap;
}

.dropdown .navbar-link:hover {
  background-color: #939393;
  color: #76bbe9;
}

.desktop-navbar {
  display: flex;
}

.navbar-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-weight: 800;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform 0.3s, border-color 0.3s;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.navbar-btn:hover {
  transform: scale(0.9);
  border-color: white;
}
.indicator {
  position: relative;
  /* other styling */
}

.indicator .cart-icon {
  color: #000000;
  height: 2.5rem;
  width: 2.5rem;
  cursor: pointer;
  border-radius: 50%;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }
}

.indicator-item {
  position: absolute;
  top: -10px;
  right: 0;
}

.quote-btn,
.phone-btn {
  background-color: #247a97;
  fill: #ffffff;
  color: #ffffff;
  position: absolute;
  letter-spacing: 0.5px;
  transition: transform 0.3s;
  font-size: 1rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0px 10px 0px;
  padding: 15px 40px 15px 40px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
}

.quote-btn {
  top: 5rem;
  right: 25vw;
}

.phone-btn {
  top: 5rem;
  left: 35vw;
}

.navbar-btn:hover {
  background-color: #247a97;
}

/* Account Login Button */
.navbar1 .Btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition-duration: 0.3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);
  background-color: #247a97;
}

/* plus sign */
.navbar1 .sign {
  width: 100%;
  transition-duration: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar1 .sign svg {
  width: 17px;
}

.navbar1 .sign svg path {
  fill: white;
}
/* text */
.navbar1 .text-login-btn {
  position: absolute;
  right: 0%;
  width: 0%;
  opacity: 0;
  color: white;
  font-size: 1.2em;
  font-weight: 600;
  transition-duration: 0.3s;
}
/* hover effect on button width */
.navbar1 .Btn:hover {
  width: 125px;
  border-radius: 40px;
  transition-duration: 0.3s;
}

.navbar1 .Btn:hover .sign {
  width: 30%;
  transition-duration: 0.3s;
  padding-left: 20px;
}
/* hover effect button's text */
.navbar1.Btn:hover .text {
  opacity: 1;
  width: 70%;
  transition-duration: 0.3s;
  padding-right: 10px;
}
/* button click effect*/
.navbar1 .Btn:active {
  transform: translate(2px, 2px);
}
/* End of Account Login Button */

/* Media query for screens with width ≤ 670px */
@media screen and (max-width: 670px) {
  .logo {
    position: absolute;
    left: 5rem;
    top: 5rem;
    transform: scale(0.5);
  }

  .contactButtons {
    gap: 0rem;
  }

  .navbar-btn.phone-btn,
  .navbar-btn.quote-btn {
    position: static;
    margin: 15px 0;
    transform: scale(0.8);
  }
}

@media (min-width: 768px) {
  .logged-in-avatar {
    height: 3rem;
    width: 3rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
}

/* Media query for screens with width ≤ 890px */
@media screen and (max-width: 890px) {
  .contactButtons {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 3vh;
    left: 27vw;
  }

  .navbar-btn.phone-btn,
  .navbar-btn.quote-btn {
    position: static;
    margin: 15px 0;
  }
}

/* Media query for screens with width ≤ 991px */
@media screen and (max-width: 991px) {
  .navbar1 {
    background-color: #939393;
    padding: 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    top: 65px;
    z-index: 20;
    justify-content: space-evenly;
    align-items: center;
    text-decoration: none;
    color: #ffffff;
    font-weight: 800;
    font-size: 1.5rem;
    transition: color 0.3s;
    margin-bottom: 1rem;
    margin: 0 15px 0 0;

    &:hover {
      color: #76bbe9;
    }
  }

  .desktop-navbar {
    display: none;
  }

  .navbar1 {
    width: 100%;
  }

  .navbar1 .navbar-item {
    font-size: 3rem;
  }

  .scrolltext-icon,
  .logged-in-avatar {
    height: 4rem;
    width: 4rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .cart-and-indicator-icon {
    scale: 1.5;
    margin-top: 22px;
  }

  .logo {
    position: absolute;
    left: 3rem;
    top: 5rem;
    transform: scale(3);
  }

  .navbar-btn {
    display: block;
    width: 100%;
    margin: 5px 0;
  }

  .phone-btn {
    width: -moz-fit-content;
    width: fit-content;
    border-color: white;
  }

  .quote-btn {
    width: -moz-fit-content;
    width: fit-content;
  }

  .quote-btn,
  .phone-btn {
    font-size: 1rem;
    font-weight: 600;
    border-width: 4px 4px 4px 4px;
    border-style: solid;
    border-radius: 10px 0px 10px 0px;
    padding: 5px 20px 5px 20px;
    box-shadow: 5px 5px 5px 0px
      rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
  }
}

@media screen and (min-width: 992px) {
  .logo {
    display: none;
  }

  .navbar-btn {
    display: none;
  }

  .menu-toggle {
    display: none;
  }

  .indicator {
    position: relative;
    &:hover {
      transform: scale(1.1);
    }
  }

  .indicator .cart-icon {
    margin-top: 5px;
    height: 3rem;
    width: 3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Navbar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,SAAS;EACT,OAAO;EACP,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B;0DACwD;AAC1D;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,iCAAiC;AACjC;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;AACA,+BAA+B;AAC/B;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;AACA,gCAAgC;;AAEhC,+CAA+C;AAC/C;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,gCAAgC;IAChC,0BAA0B;IAC1B;4DACwD;EAC1D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".navbar1 {\n  background-color: #939393;\n  padding: 1rem 0;\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-evenly;\n  position: relative;\n}\n\n.logo {\n  border-radius: 5rem;\n  position: absolute;\n  left: 5vw;\n}\n\n.scrolltext-icon {\n  color: #000000;\n  height: 3rem;\n  width: 3rem;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: transform 0.3s;\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n.logged-in-avatar {\n  height: 3rem;\n  width: 3rem;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: transform 0.3s;\n  &:hover {\n    transform: scale(1.5);\n  }\n}\n\n.navbar-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  font-weight: 800;\n  font-size: 1.75rem;\n  transition: color 0.3s;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: #76bbe9;\n  }\n}\n\n.navbar-item {\n  justify-content: start;\n  /* align-items: center; */\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 1.7rem;\n  flex-wrap: wrap;\n  transition: color 0.3s;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: #76bbe9;\n  }\n}\n\n.navbar-link {\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 1.5rem;\n  transition: color 0.3s;\n  margin-bottom: 1rem;\n\n  &:hover {\n    color: #76bbe9;\n  }\n}\n\n.dropdown {\n  display: none;\n  position: absolute;\n  background-color: #939393;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  top: 100%;\n  left: 0;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.navbar-item:hover .dropdown {\n  display: block;\n}\n\n.dropdown .navbar-link {\n  padding: 10px 15px 10px 0;\n  display: block;\n  white-space: nowrap;\n}\n\n.dropdown .navbar-link:hover {\n  background-color: #939393;\n  color: #76bbe9;\n}\n\n.desktop-navbar {\n  display: flex;\n}\n\n.navbar-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  font-weight: 800;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: transform 0.3s, border-color 0.3s;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.navbar-btn:hover {\n  transform: scale(0.9);\n  border-color: white;\n}\n.indicator {\n  position: relative;\n  /* other styling */\n}\n\n.indicator .cart-icon {\n  color: #000000;\n  height: 2.5rem;\n  width: 2.5rem;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: transform 0.3s;\n  &:hover {\n    transform: scale(1.1);\n  }\n}\n\n.indicator-item {\n  position: absolute;\n  top: -10px;\n  right: 0;\n}\n\n.quote-btn,\n.phone-btn {\n  background-color: #247a97;\n  fill: #ffffff;\n  color: #ffffff;\n  position: absolute;\n  letter-spacing: 0.5px;\n  transition: transform 0.3s;\n  font-size: 1rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0px 10px 0px;\n  padding: 15px 40px 15px 40px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n}\n\n.quote-btn {\n  top: 5rem;\n  right: 25vw;\n}\n\n.phone-btn {\n  top: 5rem;\n  left: 35vw;\n}\n\n.navbar-btn:hover {\n  background-color: #247a97;\n}\n\n/* Account Login Button */\n.navbar1 .Btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition-duration: 0.3s;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.199);\n  background-color: #247a97;\n}\n\n/* plus sign */\n.navbar1 .sign {\n  width: 100%;\n  transition-duration: 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.navbar1 .sign svg {\n  width: 17px;\n}\n\n.navbar1 .sign svg path {\n  fill: white;\n}\n/* text */\n.navbar1 .text-login-btn {\n  position: absolute;\n  right: 0%;\n  width: 0%;\n  opacity: 0;\n  color: white;\n  font-size: 1.2em;\n  font-weight: 600;\n  transition-duration: 0.3s;\n}\n/* hover effect on button width */\n.navbar1 .Btn:hover {\n  width: 125px;\n  border-radius: 40px;\n  transition-duration: 0.3s;\n}\n\n.navbar1 .Btn:hover .sign {\n  width: 30%;\n  transition-duration: 0.3s;\n  padding-left: 20px;\n}\n/* hover effect button's text */\n.navbar1.Btn:hover .text {\n  opacity: 1;\n  width: 70%;\n  transition-duration: 0.3s;\n  padding-right: 10px;\n}\n/* button click effect*/\n.navbar1 .Btn:active {\n  transform: translate(2px, 2px);\n}\n/* End of Account Login Button */\n\n/* Media query for screens with width ≤ 670px */\n@media screen and (max-width: 670px) {\n  .logo {\n    position: absolute;\n    left: 5rem;\n    top: 5rem;\n    transform: scale(0.5);\n  }\n\n  .contactButtons {\n    gap: 0rem;\n  }\n\n  .navbar-btn.phone-btn,\n  .navbar-btn.quote-btn {\n    position: static;\n    margin: 15px 0;\n    transform: scale(0.8);\n  }\n}\n\n@media (min-width: 768px) {\n  .logged-in-avatar {\n    height: 3rem;\n    width: 3rem;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n}\n\n/* Media query for screens with width ≤ 890px */\n@media screen and (max-width: 890px) {\n  .contactButtons {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    top: 3vh;\n    left: 27vw;\n  }\n\n  .navbar-btn.phone-btn,\n  .navbar-btn.quote-btn {\n    position: static;\n    margin: 15px 0;\n  }\n}\n\n/* Media query for screens with width ≤ 991px */\n@media screen and (max-width: 991px) {\n  .navbar1 {\n    background-color: #939393;\n    padding: 10px 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    top: 65px;\n    z-index: 20;\n    justify-content: space-evenly;\n    align-items: center;\n    text-decoration: none;\n    color: #ffffff;\n    font-weight: 800;\n    font-size: 1.5rem;\n    transition: color 0.3s;\n    margin-bottom: 1rem;\n    margin: 0 15px 0 0;\n\n    &:hover {\n      color: #76bbe9;\n    }\n  }\n\n  .desktop-navbar {\n    display: none;\n  }\n\n  .navbar1 {\n    width: 100%;\n  }\n\n  .navbar1 .navbar-item {\n    font-size: 3rem;\n  }\n\n  .scrolltext-icon,\n  .logged-in-avatar {\n    height: 4rem;\n    width: 4rem;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .cart-and-indicator-icon {\n    scale: 1.5;\n    margin-top: 22px;\n  }\n\n  .logo {\n    position: absolute;\n    left: 3rem;\n    top: 5rem;\n    transform: scale(3);\n  }\n\n  .navbar-btn {\n    display: block;\n    width: 100%;\n    margin: 5px 0;\n  }\n\n  .phone-btn {\n    width: fit-content;\n    border-color: white;\n  }\n\n  .quote-btn {\n    width: fit-content;\n  }\n\n  .quote-btn,\n  .phone-btn {\n    font-size: 1rem;\n    font-weight: 600;\n    border-width: 4px 4px 4px 4px;\n    border-style: solid;\n    border-radius: 10px 0px 10px 0px;\n    padding: 5px 20px 5px 20px;\n    box-shadow: 5px 5px 5px 0px\n      rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .logo {\n    display: none;\n  }\n\n  .navbar-btn {\n    display: none;\n  }\n\n  .menu-toggle {\n    display: none;\n  }\n\n  .indicator {\n    position: relative;\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  .indicator .cart-icon {\n    margin-top: 5px;\n    height: 3rem;\n    width: 3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
